@if (showDragToolTip()) {
  <div class="d-flex align-items-center">
    <i class="fal fa-info-circle mr-5 i-12"></i>
    <span class="">Select or drag fields to populate this visual</span>
  </div>
}
@if (visualType()?.previewGreyImageUrl) {
  <div class="d-flex align-items-center justify-content-center h-50p flex-grow">
    <img class="h-50p" [src]="visualType().previewGreyImageUrl">
  </div>
}